import * as Yup from "yup";

Yup.addMethod(Yup.string, 'maxWords', function (max, message) {
    return this.test('maxWords', message, function (value) {
        const { path, createError } = this;
        if (value) {
            const wordCount = value.trim().split(/\s+/).length;
            if (wordCount > max) {
                return createError({ path, message });
            }
        }
        return true;
    });
});

export const MessageReplySchema = Yup.object({
    answer: Yup.string().maxWords(500, 'Word Limit Exceed - The reply must be at most 500 words').required("Enter Reply Message"),
});